import { render, staticRenderFns } from "./profile-view-notes.vue?vue&type=template&id=ea39eb4e&"
import script from "./profile-view-notes.vue?vue&type=script&lang=js&"
export * from "./profile-view-notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports